import {TagSchema} from 'constants/RegistryConstants';
import {RegistrationTableType} from 'notebook/registration-tables/RegistrationTableConstants';

interface RegistrationTableNameParams {
  tableType: RegistrationTableType;
  tagSchema: TagSchema;
}

export function getRegistrationTableName({tableType, tagSchema}: RegistrationTableNameParams): string {
  const tableTypeName = tableType === RegistrationTableType.BATCH ? 'Batches' : 'Entities';
  return `${tagSchema.name} ${tableTypeName}`;
}
